@if (isMobilePopup) {
  <!-- Selectbox: shows the chosen method; opens a dialog over the widget to change it -->
  <div class="wb-payment-select" (click)="open = true" [formGroup]="control">
    @if (selectedGateway?.icon && svgIcons.has(iconName(selectedGateway.icon))) {
      <mat-icon svgIcon="{{iconName(selectedGateway.icon)}}" class="payment-icon"></mat-icon>
    }
    @if (selectedGateway?.icon && !svgIcons.has(iconName(selectedGateway.icon))) {
      <mat-icon class="payment-icon">{{iconName(selectedGateway.icon)}}</mat-icon>
    }
    <span class="wb-payment-select-label">
      {{ (selectedGateway ? (selectedGateway.description.toLowerCase() | translate | ucFirst) : ('select_payment_method' | translate | ucFirst)) }}
    </span>
    <app-svg-icon class="wb-payment-select-chevron" [icon]="'chevron-down'"></app-svg-icon>
  </div>
  <!-- Dialog over the widget -->
  @if (open) {
    <div class="wb-payment-dialog" [formGroup]="control">
      <div class="wb-payment-dialog-backdrop" (click)="open = false"></div>
      <div class="wb-payment-dialog-panel">
        <div class="wb-payment-dialog-head">
          <span>{{ 'payment_method' | translate | ucFirst }}</span>
          <span class="wb-payment-dialog-close" (click)="open = false">&times;</span>
        </div>
        @for (gateway of gateways; track gateway) {
          <div
            class="wb-payment-option"
            [class.selected]="control.get(config.property)?.value === gateway.id"
            (click)="selectGateway(gateway.id)"
            >
            @if (gateway.icon && svgIcons.has(iconName(gateway.icon))) {
              <mat-icon svgIcon="{{iconName(gateway.icon)}}" class="payment-icon"></mat-icon>
            }
            @if (gateway.icon && !svgIcons.has(iconName(gateway.icon))) {
              <mat-icon class="payment-icon">{{iconName(gateway.icon)}}</mat-icon>
            }
            <div class="wb-payment-label">
              {{ gateway.description.toLowerCase() | translate | ucFirst }}
              @if (gateway.calculatedCosts) {
                (+{{ gateway.calculatedCosts / 100 | currency:this._state.currency:'symbol':'1.2-2' }})
              }
            </div>
            @if (control.get(config.property)?.value === gateway.id) {
              <div class="wb-payment-check">
                <svg width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 7L6 11L15 1" stroke="#fff" stroke-width="2" fill="none" />
                </svg>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
} @else {
  <div class="wb-payment-options" [formGroup]="control">
    @for (gateway of gateways; track gateway) {
      <div
        class="wb-payment-option"
        [class.selected]="control.get(config.property)?.value === gateway.id"
        (click)="control.get(config.property)?.setValue(gateway.id)"
        >
        @if (gateway.icon && svgIcons.has(iconName(gateway.icon))) {
          <mat-icon svgIcon="{{iconName(gateway.icon)}}" class="payment-icon"></mat-icon>
        }
        @if (gateway.icon && !svgIcons.has(iconName(gateway.icon))) {
          <mat-icon class="payment-icon">{{iconName(gateway.icon)}}</mat-icon>
        }
        <div class="wb-payment-label">
          {{ gateway.description.toLowerCase() | translate | ucFirst }}
          @if (gateway.calculatedCosts) {
            (+{{ gateway.calculatedCosts / 100 | currency:this._state.currency:'symbol':'1.2-2' }})
          }
        </div>
        @if (control.get(config.property)?.value === gateway.id) {
          <div class="wb-payment-check">
            <svg width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 7L6 11L15 1" stroke="#fff" stroke-width="2" fill="none" />
            </svg>
          </div>
        }
      </div>
    }
  </div>
}

